import { SMSEditor } from '@/components/sms-editor/sms-editor';
import { Descendant } from 'slate';

// For testing/playground usage
export function SMSEditorPlayground() {
  const handleChange = (editorState: Descendant[]) => {
    console.log(editorState);
  };

  return (
    <div className="w-full max-w-2xl mx-auto p-6">
      <SMSEditor onChange={handleChange} />
    </div>
  );
}
